// 3rd party and inbuilt
import React from "react";
import classnames from "classnames";
import AutorenewRoundedIcon from "@material-ui/icons/AutorenewRounded";
import IconButton from "@material-ui/core/IconButton";
import { Tooltip } from "@my-scoot/component-library-legacy";

// style and utils
import style from "./DesktopEmailDrip.module.css";
import { apiKeys } from "../../ActiveDrip/activeDripConfig";
import { emailStatsVariant } from "./EmailDripItem.constants";

// Components
import { calculateRate } from "utils/mathUtils";
import { pluralise } from "utils/Utils";

function DesktopStats({ data, statsVariant = emailStatsVariant.DEFAULT }) {
  const totalEmailsSent = data[apiKeys.totalEmailsSent] || 0;
  const totalOpenCount = data[apiKeys.totalOpenCount] || 0;

  const totalClicksNumber = data[apiKeys.totalClicksNumber] || 0;
  const clickRate = calculateRate(totalClicksNumber, totalEmailsSent);

  const isOpaque = statsVariant === emailStatsVariant.WITH_WITH_OVERLAY;
  const isGreyedOut = statsVariant === emailStatsVariant.GREYED_OUT;
  const hasSentEmail = Boolean(totalEmailsSent);

  const getColorClass = (color) =>
    isGreyedOut ? "tw-text-[rgba(39,37,34,0.6)]" : color;

  const statItemClass = (hasBorder = true) =>
    classnames(
      "tw-inline-block tw-px-5 tw-text-base tw-leading-[19px] tw-tracking-[0.04em]",
      hasBorder &&
        "tw-border-solid tw-border-t-0 tw-border-b-0 tw-border-r-0 tw-border-l-[1.5px] tw-border-[#C4C4C4]",
      isGreyedOut && "tw-text-[rgba(39,37,34,0.6)]"
    );

  const statsValueClass = (color) =>
    classnames(
      "tw-mb-2 tw-text-base tw-font-bold tw-leading-5 tw-tracking-[0.04em]",
      getColorClass(color)
    );

  return (
    <div
      className={classnames(
        "tw-flex tw-justify-between tw-border-solid tw-border-b-0 tw-border-r-0 tw-border-l-0 tw-border-t tw-border-[#E7E6E4] !tw-p-[15.5px_5px_16px_19.5px]",
        isOpaque && "tw-opacity-50"
      )}
    >
      <div className="tw-flex">
        <div
          className={classnames(
            "tw-inline-block tw-pr-5 tw-text-base tw-leading-[19px] tw-tracking-[0.04em]",
            isGreyedOut && "tw-text-[rgba(39,37,34,0.6)]"
          )}
        >
          <div className={statsValueClass("tw-text-[#493AB1]")}>
            {totalEmailsSent}
          </div>
          <div>Sends</div>
        </div>

        <div className={statItemClass()}>
          <div className={statsValueClass("tw-text-[#086F86]")}>
            {totalOpenCount}
          </div>
          <div>Opened by</div>
        </div>

        <div className={statItemClass()}>
          <div className={statsValueClass("tw-text-[#0052C9]")}>
            {hasSentEmail ? (
              <>
                {clickRate} %
                <span className="font_sm ml-1">
                  ({totalClicksNumber} {pluralise("click", totalClicksNumber)})
                </span>
              </>
            ) : (
              "-"
            )}
          </div>
          <div>Click rate</div>
        </div>

        <div className={statItemClass()}>
          <div className={statsValueClass("tw-text-[#CC5C5C]")}>
            {hasSentEmail ? data[apiKeys.unsubscribedCount] || 0 : "-"}
          </div>
          <div>Unsubscribed</div>
        </div>
      </div>
    </div>
  );
}

function DesktopEmailDripItem({
  data,
  fieldConfig,
  showStats,
  statsVariant,
  writeDisabled,
  handleEdit,
  actions = [],
  HeaderIcon = AutorenewRoundedIcon,
  headerFormatter = () => null,
}) {
  return (
    <section className={style.container}>
      <div className={style.header}>
        <HeaderIcon className={style.headIcon} />
        <div className={style.headContentWrap}>
          <div
            className={classnames("ellipsis", style.headContent)}
            onClick={() => {
              if (writeDisabled) return;
              handleEdit(data);
            }}
          >
            {headerFormatter(data)}
          </div>
        </div>

        <div className={style.headerRightNode}>
          <div className={style.desktopActionWrap}>
            {actions.map(({ icon, label, onClick, disabled }) => (
              <IconButton
                className={style.desktopAction}
                onClick={() => onClick(data)}
                key={label}
                disabled={disabled}
              >
                <Tooltip arrow color="primary" placement="top" title={label}>
                  {icon}
                </Tooltip>
              </IconButton>
            ))}
          </div>
        </div>
      </div>
      <div className={style.fieldContainer}>
        {fieldConfig.map(({ label, source, format, className }) => (
          <div className={classnames(style.fieldRow, className)} key={label}>
            <span>{label}: </span>
            <span>{format ? format(data) : data[source] || "-"}</span>
          </div>
        ))}
      </div>
      {showStats && <DesktopStats data={data} statsVariant={statsVariant} />}
    </section>
  );
}

export default DesktopEmailDripItem;
